
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReportShowConfigV5Item } from "@/lib/model/exam/result";
import {
  CandidateNewResult,
  EnumAutoSubmitType
} from "@/lib/model/exam/candidate-result";

// enum EnumAutoSubmitType {
//   EnumAutoSubmitNormal = 0,
//   EnumAutoSubmitTypeTime = 1,
//   EnumAutoSubmitTypeScreen = 2,
//   EnumAutoSubmitTypeJump = 3,
//   EnumAutoSubmitTypeLr1 = 4,
//   EnumAutoSubmitTypeLr2 = 5,
//   EnumAutoSubmitTypeExpire = 6,
//   EnumAutoSubmitTypeRepeatCreate1 = 7,
//   EnumAutoSubmitTypeRepeatCreate2 = 8
// }

const map = new Map();
map.set(EnumAutoSubmitType.EnumAutoSubmitNormal, "规定时间内正常完成");
map.set(EnumAutoSubmitType.EnumAutoSubmitTypeTime, "系统自动结束");
map.set(EnumAutoSubmitType.EnumAutoSubmitTypeScreen, "截屏触发强制交卷");
map.set(EnumAutoSubmitType.EnumAutoSubmitTypeJump, "切屏触发强制交卷");
map.set(EnumAutoSubmitType.EnumAutoSubmitTypeLr1, "人脸核验匹配失败强制交卷");
map.set(
  EnumAutoSubmitType.EnumAutoSubmitTypeLr2,
  "人脸核验超过最大次数强制交卷"
);
map.set(EnumAutoSubmitType.EnumAutoSubmitTypeExpire, "面试过期自动结束");
map.set(
  EnumAutoSubmitType.EnumAutoSubmitTypeRepeatCreate1,
  "系统新增邀请记录触发强制交卷"
);
map.set(
  EnumAutoSubmitType.EnumAutoSubmitTypeRepeatCreate2,
  "系统新增邀请记录触发强制交卷(已登记)"
);
map.set(
  EnumAutoSubmitType.EnumAutoSubmitTypeOpenapi1,
  "系统对接新增邀请记录触发强制交卷"
);
map.set(
  EnumAutoSubmitType.EnumAutoSubmitTypeOpenapi2,
  "系统对接新增邀请记录触发强制交卷(已登记)"
);
map.set(
  EnumAutoSubmitType.EnumAutoSubmitTypeNameIdCheck,
  "姓名或证件号与实际证件不匹配强制交卷"
);

@Component({})
export default class Comp0 extends Vue {
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: "" }) connectCode!: string;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  get useTimeSecond() {
    const startTime = this.all.candidateInfo.timeInfo.beginTime;
    const endTime = this.all.candidateInfo.timeInfo.submitTime;
    return Math.floor(
      (new Date(endTime).getTime() - new Date(startTime).getTime()) / 1000
    );
  }

  get isSelfSubmit() {
    return this.all.candidateInfo.timeInfo.autoSubmitType === 0;
  }

  get showPositionName() {
    return (
      this.all.examInfo.positionName &&
      !this.option.optionMap.hiddenPositionName
    );
  }

  getText(type: number) {
    return map.get(type);
  }
}
